module.exports = __webpack_public_path__ + "static/media/img74.4430c004.jpg";